module.exports = __webpack_public_path__ + "media/Mi.376c2fcd.wav";